<template>
  <BaseReferenceTable
    title="Платформы"
    entity-name="Платформа"
    :headers="headers"
    :api="api"
    no-data-icon="mdi-layers"
    no-data-text="Платформы не найдены"
    @load-data="loadData"
    @create-item="createItem"
    @update-item="updateItem"
    @delete-item="deleteItem"
  >
    <!-- Form fields for create/edit dialog -->
    <template #form-fields="{ item }">
      <v-text-field
        v-model="item.name"
        label="Название платформы"
        placeholder="Telegram, VKontakte, YouTube..."
        :rules="nameRules"
        required
        density="compact"
      ></v-text-field>
      
      <v-switch
        v-model="item.is_monitoring"
        label="Активный мониторинг"
        color="primary"
        density="compact"
        hide-details
        class="mt-4"
      ></v-switch>
    </template>

    <!-- Custom table columns -->
    <!-- Platform name -->
    <template v-slot:[`item.name`]="{ item }">
      <span class="font-weight-medium">{{ item.name }}</span>
    </template>
    
    <!-- Monitoring status -->
    <template v-slot:[`item.is_monitoring`]="{ item }">
      <v-chip
        :color="item.is_monitoring ? 'success' : 'default'"
        size="small"
        variant="tonal"
      >
        <v-icon start size="x-small">
          {{ item.is_monitoring ? 'mdi-check-circle' : 'mdi-pause-circle' }}
        </v-icon>
        {{ item.is_monitoring ? 'Активен' : 'Отключен' }}
      </v-chip>
    </template>
  </BaseReferenceTable>
</template>

<script>
// import { ref } from 'vue' // убрано - не используется
import BaseReferenceTable from './BaseReferenceTable.vue'
import { referenceApi } from '@/services/api/referenceApi'

export default {
  name: 'PlatformsTable',
  components: {
    BaseReferenceTable
  },
  setup() {
    const api = referenceApi

    const headers = [
      { 
        title: 'Название', 
        key: 'name', 
        sortable: true 
      },
      {
        title: 'Мониторинг',
        key: 'is_monitoring',
        sortable: true,
        width: '120px'
      }
    ]

    // Validation rules
    const nameRules = [
      v => !!v || 'Название платформы обязательно',
      v => (v && v.length >= 1 && v.length <= 100) || 'Название должно содержать от 1 до 100 символов'
    ]

    // Methods
    const loadData = async ({ page, limit, callback }) => {
      try {
        const skip = (page - 1) * limit
        const response = await api.getPlatforms({ skip, limit })
        callback(response.data)
      } catch (error) {
        console.error('Error loading platforms:', error)
        callback(null, 'Ошибка загрузки платформ. Проверьте подключение к серверу.')
      }
    }

    const createItem = async ({ item, callback }) => {
      try {
        // Ensure is_monitoring has a default value
        if (item.is_monitoring === undefined) {
          item.is_monitoring = true
        }
        await api.createPlatform(item)
        callback(true)
      } catch (error) {
        console.error('Error creating platform:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось создать платформу'
        callback(false, message)
      }
    }

    const updateItem = async ({ item, callback }) => {
      try {
        await api.updatePlatform(item.id, item)
        callback(true)
      } catch (error) {
        console.error('Error updating platform:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось обновить платформу'
        callback(false, message)
      }
    }

    const deleteItem = async ({ ids, callback }) => {
      try {
        await Promise.all(ids.map(id => api.deletePlatform(id)))
        callback(true)
      } catch (error) {
        console.error('Error deleting platforms:', error)
        const message = error.response?.data?.detail || error.response?.data?.message || 'Не удалось удалить платформы'
        callback(false, message)
      }
    }

    return {
      api,
      headers,
      nameRules,
      loadData,
      createItem,
      updateItem,
      deleteItem
    }
  }
}
</script>